import { MenuItem } from '@mui/material'
import { FormField } from 'global/components/Form'

interface IProps {
    required?: boolean
}

export function SelectTipoDocumento({ required }: IProps) {
    return (
        <FormField
            required={required}
            select
            name="tipoDocumento"
            label="Tipo de documento"
        >
            <MenuItem value={'CNPJ'}>CNPJ</MenuItem>
            <MenuItem value={'CAEPF'}>CAEPF</MenuItem>
            <MenuItem value={'CPF'}>CPF</MenuItem>
        </FormField>
    )
}
